<template>
  <div class="bim-steps" :class="color">
    <bim-text class="bim-steps__title mb-11 mx-auto" bold type="h5" v-if="title">
      <span v-html="title"></span>
    </bim-text>

    <div class="bim-steps__slider slider-block">
      <div class="slider-block__tabs">
        <div>
          <slot name="steps_header"></slot>
          <div
            v-for="(slide, index) of slides"
            :key="index"
            class="slider-block__slide px-10"
            :class="{ 'slider-block__slide--active': currentSlide === index }"
            @click="menuClick(index)"
          >
            <bim-text
              v-if="slide.title"
              type="main"
              class="slider-block__slide-title"
              bold
              v-html="slide.title"
            />
            <bim-text
              v-if="slide.desc"
              type="main"
              class="slider-block__slide-desc pt-3"
              v-html="slide.desc"
            />
          </div>
        </div>
      </div>
      <div class="slider-block__content content-image">
        <div
          v-for="(slide, index) of slides"
          :key="slide.img"
          v-show="currentSlide === index"
          class="content-image__wrapper"
        >
          <div class="content-image__container">
            <img alt="" :src="slide.img" class="d-block cursor-pointer" @click="openImageModal(slide.img)" />
          </div>
        </div>
      </div>
    </div>
    <bimPopup title="" v-model="imagePopup.show" width="1280px" closeOnWrapper>
      <img :src="imagePopup.image" alt="" class="popup_mage" />
    </bimPopup>
  </div>
</template>

<script>
import bimPopup from "@bimlib/components/bimPopup"
export default {
  name: "bim-steps",
  components: {
    bimPopup,
  },
  props: {
    title: String,
    /**
     * Array<{ title?: String, desc?: String, img: String }>
     */
    slides: Array,
    color: {
      type: String,
      validator: val => ['primary', 'luxury'].includes(val),
      default: 'primary',
    }
  },
  data() {
    return {
      currentSlide: 0,
      imagePopup: {
        show: false,
        image: ""
      }
    }
  },
  methods: {
    menuClick(index) {
      this.currentSlide = index;
    },
    openImageModal(image) {
      this.imagePopup.image = image
      this.imagePopup.show = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";
.bim-steps {
  &.luxury {
    .slider-block__slide--active {
      &::after {
        background-color: $luxury-color !important;
      }
      .slider-block__slide-title {
        color: $luxury-color !important;
      }
    }
  }
}

.cursor-pointer {
  cursor: pointer;
}

.bim-steps {
  .bim-steps__title {
    max-width: 1160px;

    @media screen and (max-width: $breakpoint-sm) {
      ::v-deep .text__inner {
        font-size: 20px;
      }
    }
  }
}

.slider-block {
  display: flex;
  justify-content: center;

  @media screen and (max-width: $breakpoint-lg) {
    flex-direction: column;
  }

  .slider-block__tabs,
  .slider-block__content {
    flex: 0 0 50%;
    max-width: 565px;
  }

  .slider-block__tabs {
    margin-right: 30px;

    @media screen and (max-width: $breakpoint-md) {
      margin-right: 0px;
      margin-bottom: 30px;
    }
  }

  .slider-block__slide {
    position: relative;
    cursor: pointer;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 4px;
      height: 100%;
      background-color: $white-color-100;
    }

    &:hover {
      opacity: .8;
    }

    &.slider-block__slide--active {
      .slider-block__slide-title {
        color: $primary-color;
      }
      &::after {
        background-color: $primary-color;
      }
    }

    &:not(:last-child) {
      margin-bottom: 24px;
    }
  }
  
  .slider-block__slide-title {
    font-size: 18px;
    line-height: 1.3;

    @media screen and (max-width: $breakpoint-sm) {
      font-size: 14px;
    }
  }

  .slider-block__slide-desc {
    line-height: 1.5;
    letter-spacing: 0.2px;

    @media screen and (max-width: $breakpoint-sm) {
      font-size: 14px;
    }
  }
}

.content-image {

  .content-image__container {
    height: fit-content;
  }

  .content-image__wrapper {
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    align-items: flex-end;
  }

  .content-image__image {
    display: block;
    margin: auto;
    height: 100%;
    object-fit: contain;

    @media screen and (max-width: $breakpoint-md) {
      width: 100%;
      height: auto;
    }
  }
}

.popup_mage {
  max-height: 70vh;
}
</style>
